(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mini-mint-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mini-mint-delivery')) {
    customElements.define('mini-mint-delivery', class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.picture = this.querySelector('img');
        this.button = this.querySelector('button');
        this.poster = this.picture.src;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.stop = () => {
          this.picture.src = this.poster;
          this.button.hidden = true;
        };
        this.button.onclick = this.stop;
        this.onMotion = () => { if (this.motion.matches) this.stop(); };
        this.motion.addEventListener('change', this.onMotion);
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.started = true;
          this.observer.disconnect();
          if (this.motion.matches) return;
          this.picture.src = this.picture.dataset.animation;
          this.button.hidden = false;
        }, { threshold: 0.5 });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.motion?.removeEventListener('change', this.onMotion);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
